var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateZone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    "area-hidden": "false",
    "aria-label": "Create Zone",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Create Zone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2333 18.255H5.61112V5.63273H18.2333V18.255ZM6.84747 17.0186H16.997V6.86909H6.84747V17.0186ZM18.2333 2H16.9833V4.48589H18.2333V2ZM22 5.63273H19.5141V6.88273H22V5.63273ZM6.86112 2H5.61112V4.48589H6.86112V2ZM4.48589 5.63273H2V6.88273H4.48589V5.63273ZM4.48589 17.005H2V18.255H4.48589V17.005ZM22 17.005H19.5141V18.255H22V17.005ZM6.86112 19.5141H5.61112V22H6.86112V19.5141ZM18.2333 19.5141H16.9833V22H18.2333V19.5141Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateZone);
export default __webpack_public_path__ + "static/media/create-zone.e4b2d6299fa67ae05bc347a4f0557347.svg";
export { ForwardRef as ReactComponent };